import { FileUpload } from '@palmetto/palmetto-components';
import { useCallback, useMemo } from 'react';
import type { ComponentProps, MouseEvent } from 'react';

type FileUploadProps = ComponentProps<typeof FileUpload>;

/**
 * Clears the underlying <input> each time the picker opens so re-selecting the
 * same file(s) still fires onChange. Without this the input keeps its previous
 * FileList and the upload button appears dead until a full page refresh —
 * most visible right after a failed upload.
 */
export function ResettingFileUpload({ inputProps, ...props }: FileUploadProps) {
  const consumerOnClick = inputProps?.onClick;

  const handleInputClick = useCallback(
    (event: MouseEvent<HTMLInputElement>) => {
      event.currentTarget.value = '';
      consumerOnClick?.(event);
    },
    [consumerOnClick],
  );

  const mergedInputProps = useMemo(
    () => ({ ...inputProps, onClick: handleInputClick }),
    [inputProps, handleInputClick],
  );

  return <FileUpload {...props} inputProps={mergedInputProps} />;
}
